export const environment = {
  local: false,
  dev: false,
  homolog: false,
  demo: false,
  prod: true,
};

export const urlApi = `https://api-administracao.buspay.com.br/bilhetagem/administracao/api`;
export const urlApiLogin = `https://api-administracao.buspay.com.br/bilhetagem/autenticacao/api`;
export const urlSignalR = `https://api-administracao.buspay.com.br`;
export const versaoApp = `3.36.1`;

export const configuracaoDoCognitoAuth = {
  userPoolId: "sa-east-1_2IOg4b9SY",
  userPoolWebClientId: "6i0nhqe4n5u988cqhgs2mqujms",
  region: "sa-east-1",
};

export const tipoAutenticacaoMfaCognito: "app" | "sms" | "email" = "email";
